/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { type HttpResponse, I18nService } from '@dm/core';
import { type Observable } from 'rxjs';

import { LunsConst } from '../../../../../../service/block-service/lun-group/luns.const';
import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-lun-group-base-info',
    templateUrl: './lun-group-base-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LunGroupBaseInfoComponent extends RefreshComponent {
    @Input() item;
    baseInfo;
    detail: any = {};
    loading = true;
    capacityPercentData = 0;

    constructor(private infigoService: InfigoService,
        public str: LunsConst,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public changeDetectorRef: ChangeDetectorRef) {
        super();
        const I18N = i18n.get;
        const enumGet = enumService.get.bind(enumService, 'LUNGROUP');
        this.baseInfo = [
            {
                title: I18N('storage.LunGroup_term_LUNCount_column'),
                key: 'lunNumber',
            },
            {
                title: I18N('common.mapping_column'),
                key: 'ISADD2MAPPINGVIEW',
                enumMap: enumGet('ISADD2MAPPINGVIEW'),
            },
            {
                title: I18N('common.description_column'),
                key: 'DESCRIPTION',
                isLongString: true,
            },
        ];
    }

    requestInfo(): Observable<HttpResponse> {
        return this.infigoService.getLUNGroupDetail(this.item.actionParams);
    }

    handleRequest(value: { data: any }): void {
        this.loading = false;
        this.detail = value.data;
        this.clearTimer();
        this.updateLoading = false;
        this.capacityPercentData = this.infigoService.usageValue(this.detail);
        this.changeDetectorRef.detectChanges();
    }
}
